import React, { useState, useEffect } from "react";
import $ from "jquery";
import { AiFillSave } from "react-icons/ai";

const CompleteData = (props) => {
  const userData = props.userJson;
  const [cityId, setCityId] = useState(props.userJson.city_id);
  const [stateId, setStateId] = useState(props.userJson.state_id);

  useEffect(() => {
    setStateId(props.userJson.state_id);
  }, [props.userJson.state_id]);
  useEffect(() => {
    setCityId(props.userJson.city_id);
  }, [props.userJson.city_id]);
  useEffect(() => {
    if (stateId > 0) props.getCity(stateId);
  }, [stateId]);
  console.log(cityId, stateId);
  $(".NumberValid").on("input", function() {
    var e = "۰".charCodeAt(0);
    this.value = this.value.replace(/[۰-۹]/g, function(t) {
      return t.charCodeAt(0) - e;
    });
    e = "٠".charCodeAt(0);
    this.value = this.value.replace(/[٠-٩]/g, function(t) {
      return t.charCodeAt(0) - e;
    });
    this.value = this.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
  });

  $(".valid-empty").on("blur", function() {
    var value_check = $(this).val();
    value_check = value_check.replace(/\s/g, "");
    if (value_check === null || value_check.length < 1) {
      $(this)
        .removeClass("is-valid")
        .addClass("is-invalid");
      $(this)
        .next(".invalid-feedback")
        .text("فیلد نمی تواند خالی باشد.");
      return false;
    }
    $(this)
      .removeClass("is-invalid")
      .addClass("is-valid");
  });

  function checkItem(e) {
    var value_check = $(e).val();
    value_check = value_check.replace(/\s/g, "");
    if (value_check === null || value_check.length < 1) {
      $(e)
        .removeClass("is-valid")
        .addClass("is-invalid");
      $(e)
        .next(".invalid-feedback")
        .text("فیلد نمی تواند خالی باشد.");
      return false;
    }
    $(e)
      .removeClass("is-invalid")
      .addClass("is-valid");
  }
  const Validation = () => {
    let isValid = true;
    let national_id = $("#User_CodeMeli").val();
    let postal_code = $("#User_PostalCode").val();
    let bank_shaba = $("#User_BankShaba").val();
    const nationalId_Regex = /^[0-9]{10}/;
    const postalCode_Regex = /^[0-9]{10}/;
    const shabaCode_Regex = /^[0-9]{24}/;
    if (!nationalId_Regex.test(national_id)) {
      isValid = false;
      props.toggleErrorMessage("کدملی وارد شده اشتباه است.");
      return isValid;
    }
    if (!postalCode_Regex.test(postal_code)) {
      isValid = false;
      props.toggleErrorMessage("کدپستی وارد شده اشتباه است.");
      return isValid;
    }
    if (!shabaCode_Regex.test(bank_shaba)) {
      isValid = false;
      props.toggleErrorMessage("شماره شبای وارد شده اشتباه است.");
      return isValid;
    }
    return isValid;
  };
  function submitForm() {
    $(".valid-empty").each(function(i, obj) {
      checkItem($(obj));
    });
    var numItems = $(".is-invalid").length;
    const isValid = Validation();
    if (numItems === 0 && isValid) {
      const token = localStorage.getItem("token");
      if (token !== null) {
        var formdata = new FormData();
        formdata.append("first_name", $("#User_Fname").val());
        formdata.append("last_name", $("#User_Lname").val());
        formdata.append("bank_name", $("#User_BankName").val());
        formdata.append("bank_shaba", $("#User_BankShaba").val());
        formdata.append("national_id", $("#User_CodeMeli").val());
        formdata.append("shop_name", $("#User_StoreName").val());
        formdata.append("address", $("#User_Address").val());
        formdata.append("postal_code", $("#User_PostalCode").val());
        formdata.append("city_id", $("#City_ID").val());
        formdata.append("token", token);
        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
        };

        fetch(
          `${process.env.REACT_APP_BASE_URL}/api/user/save-full-profile`,
          requestOptions
        )
          .then((response) => response.text())
          .then((result) => {
            if (result !== null) {
              var myObject = JSON.parse(result);
              if (myObject.status === 0) {
                window.location.href = "/home";
              } else {
                props.toggleErrorMessage(myObject.message);
                props.toggleError();
              }
            }
          })
          .catch((error) => console.log("error", error));
      }
    } else {
      props.toggleError();
    }
  }
  function changeCity(evt) {
    setCityId(evt.target.value);
  }
  function changeState(evt) {
    setStateId(evt.target.value);
    props.getCity(evt.target.value);
  }
  return (
    <div className="col-12 p-4 Profile">
      <div className="w-100 alert alert-warning rounded-0">
        <h6 className="text-justify mb-0">
          تعمیر کار گرامی، جهت استفاده از این نرم افزار ابتدا حساب کاربری خود را
          تکمیل کنید.
        </h6>
      </div>
      <div className="item data body-padding-bottom">
        <div className="col-12 mt-2">
          <label className="wp-text">
            نام<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            defaultValue={userData.first_name}
            id="User_Fname"
            className="form-control form-control-sm wp-input-text rounded-pill valid-empty"
            tabIndex="1"
          />
          <div className="invalid-feedback wp-text-small"></div>
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">
            نام خانوادگی<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            defaultValue={userData.last_name}
            id="User_Lname"
            className="form-control form-control-sm wp-input-text rounded-pill valid-empty"
            tabIndex="2"
          />
          <div className="invalid-feedback wp-text-small"></div>
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">
            موبایل<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            defaultValue={userData.mobile}
            id="User_Mobile"
            className="form-control form-control-sm wp-input-text rounded-pill valid-empty NumberValid"
            tabIndex="3"
            disabled
          />
          <div className="invalid-feedback wp-text-small"></div>
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">
            کدملی<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            id="User_CodeMeli"
            defaultValue={userData.national_id}
            className="form-control form-control-sm wp-input-text rounded-pill valid-empty NumberValid"
            tabIndex="4"
          />
          <div className="invalid-feedback wp-text-small"></div>
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">نام تعمیرگاه</label>
          <input
            type="text"
            id="User_StoreName"
            defaultValue={userData.shop_name}
            className="form-control form-control-sm wp-input-text rounded-pill "
            tabIndex="5"
          />
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">
            کدپستی<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            id="User_PostalCode"
            defaultValue={userData.postal_code}
            className="form-control form-control-sm wp-input-text rounded-pill valid-empty NumberValid"
            tabIndex="6"
          />
          <div className="invalid-feedback wp-text-small"></div>
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">
            استان<span className="text-danger mr-1">*</span>
          </label>
          <select
            value={stateId && stateId > 0 ? stateId : 0}
            id="Town_ID"
            name="Town_ID"
            className="form-control form-control-sm rounded-pill wp-input-text valid-empty"
            onChange={changeState}
            tabIndex="7"
          >
            <option value="0">انتخاب نمایید</option>
            {props.town.map((e) => (
              <option key={e.id} value={e.id}>
                {e.name}
              </option>
            ))}
          </select>
          <div className="invalid-feedback wp-text-small"></div>
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">
            شهر<span className="text-danger mr-1">*</span>
          </label>
          {props.city ? (
            <>
              <select
                value={cityId}
                id="City_ID"
                name="City_ID"
                className="form-control form-control-sm rounded-pill wp-input-text valid-empty"
                tabIndex="8"
                onChange={changeCity}
              >
                <option value="0">ابتدا استان را انتخاب نمایید...</option>
                {props.city.map((e) => (
                  <option key={e.id} value={e.id}>
                    {e.name}
                  </option>
                ))}
              </select>
              <div className="invalid-feedback wp-text-small"></div>
            </>
          ) : null}
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">آدرس</label>
          <textarea
            id="User_Address"
            className="form-control form-control-sm wp-input-text"
            rows="2"
            tabIndex="10"
            defaultValue={userData.address}
          ></textarea>
          <div className="invalid-feedback wp-text-small"></div>
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">
            نام بانک<span className="text-danger mr-1">*</span>
          </label>
          <input
            type="text"
            id="User_BankName"
            defaultValue={userData.bank_name}
            className="form-control form-control-sm wp-input-text rounded-pill valid-empty"
            tabIndex="11"
          />
          <div className="invalid-feedback wp-text-small"></div>
        </div>
        <div className="col-12 mt-2">
          <label className="wp-text">
            شماره شبا<span className="text-danger mr-1">*</span>
          </label>
          <input
            type="text"
            defaultValue={userData.bank_shaba}
            id="User_BankShaba"
            className="form-control form-control-sm wp-input-text rounded-pill NumberValid valid-empty"
            tabIndex="12"
          />
          <div className="invalid-feedback wp-text-small"></div>
        </div>
        <div className="col-12 mt-2">
          <button
            id="SubmitForm"
            className="btn dina-btn-blue rounded-pill float-left"
            onClick={submitForm}
          >
            <AiFillSave /> ثبت اطلاعات
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompleteData;
